var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.279 35.7484C17.3563 35.7074 14.5027 34.8539 12.0375 33.2834C9.57232 31.7129 7.59279 29.4874 6.32045 26.8559C5.0481 24.2243 4.53315 21.2907 4.83321 18.3832C5.13327 15.4756 6.23651 12.709 8.01947 10.3928C9.80242 8.07657 12.1948 6.30222 14.9287 5.26828C17.6627 4.23434 20.6305 3.9816 23.5 4.53834C26.3694 5.09509 29.0273 6.43935 31.1763 8.42071C33.3252 10.4021 34.8804 12.9423 35.6678 15.7572",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 20.0002H26.6255M20.5002 13.875L20.5002 26.1255",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8369 33.5618C26.4415 32.6746 27.2687 31.9456 28.2434 31.4409C29.2181 30.9362 30.3094 30.6719 31.4183 30.6719C32.5272 30.6719 33.6185 30.9362 34.5932 31.4409C35.5679 31.9456 36.3951 32.6746 36.9997 33.5618",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4186 28.0489C33.2014 28.0489 34.6467 26.3678 34.6467 24.294C34.6467 22.2202 33.2014 20.5391 31.4186 20.5391C29.6357 20.5391 28.1904 22.2202 28.1904 24.294C28.1904 26.3678 29.6357 28.0489 31.4186 28.0489Z",
    fill: "#F8F8F8",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockAlert);
export default __webpack_public_path__ + "static/media/clock-alert.66f1a0c5c9913e7a481e89595050d7e2.svg";
export { ForwardRef as ReactComponent };